import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { VALIDATE_ZONE, VALIDATE_ZONE_SUCCESS, VALIDATE_ZONE_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* validateZone({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/benefit-type/airport-transfer/zone/validate`,
      method: 'POST',
      data: payload?.data,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: VALIDATE_ZONE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: VALIDATE_ZONE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: VALIDATE_ZONE_ERROR, payload: error });
  }
}

export function* watchvalidateZone() {
  yield takeEvery(VALIDATE_ZONE, validateZone);
}

function* validateZoneSaga() {
  yield all([fork(watchvalidateZone)]);
}

export default validateZoneSaga;
